import http from "@/service";
import type {
  GetAccessTokenParams,
  LoginAccessTokenResponse
} from "@/types/login";

const api = {
  loginAndGetToken: "/pac-auth/oauth/token",
  checkTokenValidity: "/pac-auth/current-user",
  getCASLoginUrl: "/pac-auth/oauth2/clients/info"
};

export function loginAndGetToken(params: GetAccessTokenParams) {
  return http.post<LoginAccessTokenResponse>(api.loginAndGetToken, null, {
    params
  });
}

export function checkTokenValidity() {
  return http.get(api.checkTokenValidity);
}

export function getCASLoginUrl() {
  return http.get<
    Array<{
      registrationId: string;
      clientName: string;
      path: string;
    }>
  >(api.getCASLoginUrl);
}

// cas免密登录
export function loginWithCASToken(username: string, token: string) {
  return http.post<LoginAccessTokenResponse>(api.loginAndGetToken, null, {
    params: {
      grant_type: "tecdo_cas_token",
      client_id: "bop",
      client_secret: "bop_secret",
      username,
      token
    }
  });
}

// 切换账号登录
export function loginByChangeAccount(username: string) {
  return http.post<LoginAccessTokenResponse>(api.loginAndGetToken, null, {
    params: {
      grant_type: "bop_token",
      client_id: "bop",
      client_secret: "bop_secret",
      username
    }
  });
}
